import { GET_TRANSIT_ACCOUNT_PRODUCT_CATALOG } from 'components/data/transit-account/ProductCatalog.query.js';
import { FUNDING_SOURCES_GET_QUERY } from '../FundingSources.query';

const ReloadSessionDataQs = [
	{ query: FUNDING_SOURCES_GET_QUERY },
];

export const reloadProducts = (subsystemAccountReference, lang = null) => {
	return ({
		query: GET_TRANSIT_ACCOUNT_PRODUCT_CATALOG,
		variables: { subsystemAccountReference, lang },
	});
};

export default ReloadSessionDataQs;
